import { typography, screenSizeBreakpoints, contentMaxWidth, headerBarHeight } from './common.theme';

const colors = {
  primary: '#1C1B1E',
  secondary: '#414853',
  tertiary: '#202127',
  emphasized: '#A8B1FF',
  detail: '#5C73E7',
  text: {
    primary: '#DFDFD6',
    secondary: '#626d8e',
    tertiary: '#999',
    emphasized: '#A8B1FF',
    detail: '#5C73E7'
  },
  heading: {
    primary: '#ecf1f7',
    secondary: '#626d8e',
    tertiary: '#999',
    emphasized: '#5c73e7',
    detail: '#5c73e7'
  }
};

const theme = {
  colors: colors,
  typography: typography,
  screenSizeBreakpoints: screenSizeBreakpoints,
  contentMaxWidth: contentMaxWidth,
  headerBarHeight: headerBarHeight,
};

export default theme;
